import { storeModuleName } from "@/services/cityCenter/cityCenterService";
import {
  SET_MODULE,
  SET_PERMITTED_MODULES,
  SET_NOTIFICATIONS,
  SET_MY_TIMES,
  SET_MY_TIME,
  SET_DASHBOARD_ANNOUNCEMENTS,
  SET_DASHBOARD_MY_TASKS,
  SET_DASHBOARD_UPCOMING_EVENTS,
  SET_USER_MANAGEMENT,
  SET_ROLE_GROUP,
  SET_ROLE_GROUP_ASSOCIATION,
  SET_ROLES,
  SET_APPLICATION_LIST,
  SET_APPLICATION_CONTRACT_LIST,
  SET_USER_ASSOCIATED_ROLE_GROUPS,
  SET_SEARCHED_ROLE_GROUPS,
  SET_ASSOCIATED_ROLES,
  SET_ASSOCIATION_TYPES,
  SET_EMPLOYEE_ASSOCIATIONS,
  SET_SEARCHED_USER_LIST,
  SET_PROCESS_TYPES,
  SET_WORKFLOWS,
  SET_ACTIONS,
  SET_PROCESS_ASSOCIATIONS,
  SET_USER_GROUPS,
  SET_USERS_IN_USER_GROUP,
  SET_AVAILABLE_STATUS,
  SET_STATUS_CONFIGURATION,
  SET_USER_GROUP_ASSOCIATION,
  SET_APPROVAL_GROUPS,
  SET_USERS_IN_APPROVAL_GROUP,
  SET_ASSOCIATED_USER_GROUPS_WITH_APPROVAL_GROUP,
  SET_AVAILABLE_NEXT_STATUS
} from "@/store/cityCenter/mutation-types";

const mutations = {
  /**
   * Set current module
   * @param state
   * @param {{title: String, icon: String, name: String, route: String}} module
   * @constructor
   */
  [SET_MODULE]: (state, module) => {
    state.module = module;
    if (module) {
      storeModuleName(module.name);
    }
  },
  [SET_PERMITTED_MODULES]: (state, newPermittedModules) => {
    state.permittedModules = newPermittedModules;
  },
  /**
   * Set notifications
   * @param state
   * @param [{title: String, subtitle: String, priority: String}] payload
   */
  [SET_NOTIFICATIONS]: (state, payload) => {
    state["notifications"] = payload || [];
  },
  /**
   * SET_MY_*
   * @param state
   * @param payload
   */
  [SET_MY_TIMES]: (state, payload) => {
    state["myTimes"] = payload || [];
    // console.log("SET_MY_TIMES().myTimes:", state["myTimes"]);
  },
  [SET_MY_TIME]: (state, payload) => {
    state["myTime"] = payload || [];
    // console.log("SET_MY_TIME().myTime:", state["myTime"]);
  },
  [SET_DASHBOARD_ANNOUNCEMENTS]: (state, payload) => {
    state["dashboardAnnouncements"] = payload || [];
  },
  [SET_DASHBOARD_MY_TASKS]: (state, payload) => {
    state["dashboardMyTasks"] = payload || [];
  },
  [SET_DASHBOARD_UPCOMING_EVENTS]: (state, payload) => {
    state["dashboardUpcomingEvents"] = payload || [];
  },
  [SET_USER_MANAGEMENT]: (state, payload) => {
    state["userManagement"] = payload || [];
  },
  [SET_ROLE_GROUP]: (state, payload) => {
    state["roleGroup"] = payload || [];
  },
  [SET_ROLE_GROUP_ASSOCIATION]: (state, payload) => {
    state["roleGroupAssociation"] = payload || [];
  },
  [SET_ROLES]: (state, payload) => {
    state["roles"] = payload || [];
  },
  [SET_APPLICATION_LIST]: (state, payload) => {
    state["applicationList"] = payload || [];
  },
  [SET_APPLICATION_CONTRACT_LIST]: (state, payload) => {
    state["applicationContractList"] = payload || [];
  },
  [SET_USER_ASSOCIATED_ROLE_GROUPS]: (state, payload) => {
    state["userAssociatedRoleGroups"] = payload || [];
  },
  [SET_SEARCHED_ROLE_GROUPS]: (state, payload) => {
    state["searchedRoleGroups"] = payload || [];
  },
  [SET_ASSOCIATED_ROLES]: (state, payload) => {
    state["associatedRoles"] = payload || [];
  },
  [SET_ASSOCIATION_TYPES]: (state, payload) => {
    state["associationTypes"] = payload || [];
  },
  [SET_EMPLOYEE_ASSOCIATIONS]: (state, payload) => {
    state["employeeAssociations"] = payload || [];
  },
  [SET_SEARCHED_USER_LIST]: (state, payload) => {
    state["searchedUserList"] = payload || [];
  },
  [SET_PROCESS_TYPES]: (state, payload) => {
    state["processTypes"] = payload || [];
  },
  [SET_WORKFLOWS]: (state, payload) => {
    state["workflows"] = payload || [];
  },
  [SET_ACTIONS]: (state, payload) => {
    state["actions"] = payload || [];
  },
  [SET_PROCESS_ASSOCIATIONS]: (state, payload) => {
    state["processAssociations"] = payload || [];
  },
  [SET_USER_GROUPS]: (state, payload) => {
    state["userGroups"] = payload || [];
  },
  [SET_USERS_IN_USER_GROUP]: (state, payload) => {
    state["usersInUserGroup"] = payload || [];
  },
  [SET_AVAILABLE_STATUS]: (state, payload) => {
    state["availableStatus"] = payload || [];
  },
  [SET_STATUS_CONFIGURATION]: (state, payload) => {
    state["statusConfiguration"] = payload || [];
  },
  [SET_USER_GROUP_ASSOCIATION]: (state, payload) => {
    state["userGroupAssociation"] = payload || [];
  },
  [SET_APPROVAL_GROUPS]: (state, payload) => {
    state["approvalGroups"] = payload || [];
  },
  [SET_USERS_IN_APPROVAL_GROUP]: (state, payload) => {
    state["usersInApprovalGroup"] = payload || [];
  },
  [SET_ASSOCIATED_USER_GROUPS_WITH_APPROVAL_GROUP]: (state, payload) => {
    state["associatedUserGroupsWithApprovalGroup"] = payload || [];
  },
  [SET_AVAILABLE_NEXT_STATUS]: (state, payload) => {
    state["availableNextStatus"] = payload || [];
  }
};

export default mutations;
